<div class="custom-select-container">
	<mat-select #selectElement
				class="form-control filter-options custom-select"
				[ngClass]="extraClass"
				[value]="value"
				[matTooltip]="tooltipText"
				[disabled]="disabled"
				panelClass="multi-select-auto-panel"
				multiple
				(selectionChange)="onMatSelectionChange($event)"
				(openedChange)="onOpenedChange($event)">

		<!-- Custom trigger showing selected items -->
		<mat-select-trigger *ngIf="value?.length">
			{{ displayText }}
		</mat-select-trigger>

		<!-- Search input (sticky at top) -->
		<ng-container *ngIf="searchable">
			<div class="search-container position-sticky top-0">
				<div class="input-group">
					<input #searchInput
						   class="form-control"
						   type="text"
						   [ngModel]="searchValue"
						   (ngModelChange)="onSearchValueChange($event)"
						   (click)="$event.stopPropagation()"
						   (keydown)="$event.stopPropagation()"
						   placeholder="Search... (or paste id1, id2, id3 to auto-select)"/>
					<button type="button"
							class="btn btn-outline-secondary bi bi-trash-fill btn-picker"
							[disabled]="!searchValue"
							(click)="clearSearch(); $event.stopPropagation()">
					</button>
				</div>

				<!-- Auto-select summary -->
				<div *ngIf="autoSelectSummary" class="auto-select-summary">
					<span class="summary-found">
						<i class="bi bi-check-circle-fill me-1"></i>
						{{ autoSelectSummary.found }} / {{ autoSelectSummary.total }} {{ "SELECTED_FOUND"| translate }}
					</span>
					<span *ngIf="autoSelectSummary.notFoundIds.length > 0"
						  class="summary-not-found ms-2"
						  [matTooltip]="autoSelectSummary.notFoundIds.join(', ')"
						  matTooltipPosition="below">
						<i class="bi bi-exclamation-circle-fill me-1"></i>
						{{ autoSelectSummary.notFoundIds.length }} {{ "SELECTED_NOT_FOUND"| translate }}
					</span>
				</div>

				<!-- Selection count (shown when not in auto-select mode) -->
				<div *ngIf="!autoSelectSummary && value?.length > 0" class="selection-count">
					<i class="bi bi-check2-all me-1"></i>
					{{ value.length }} / {{ options?.length ?? 0 }} selezionati
				</div>
			</div>
		</ng-container>

		<!-- Options list with trackBy -->
		<mat-option *ngFor="let option of renderedOptions; trackBy: trackByOptionId"
					[value]="option.id">
			{{ option.name }}
		</mat-option>

		<!-- Hidden selected options (not in current page but needed in DOM for MatSelect) -->
		<mat-option *ngFor="let option of hiddenSelectedOptions; trackBy: trackByOptionId"
					[value]="option.id"
					class="hidden-option">
			{{ option.name }}
		</mat-option>

		<!-- Empty state -->
		<div *ngIf="renderedOptions?.length === 0"
			 class="empty-message w-100 text-center fw-bold mb-2 p-3">
			No result found
		</div>

		<!-- Pagination controls -->
		<div *ngIf="totalPages > 1"
			 class="pagination-controls d-flex align-items-center justify-content-center gap-1 p-2 border-top">
			<!-- First page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === 1"
					(click)="goToFirstPage($event)"
					title="First page">
				<i class="bi bi-chevron-double-left"></i>
			</button>

			<!-- Previous page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === 1"
					(click)="goToPreviousPage($event)"
					title="Previous page">
				<i class="bi bi-chevron-left"></i>
			</button>

			<!-- Page info -->
			<span class="pagination-info mx-2 text-nowrap">
				{{ currentPage }} / {{ totalPages }}
				<small class="text-muted">({{ totalFilteredCount }})</small>
			</span>

			<!-- Next page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === totalPages"
					(click)="goToNextPage($event)"
					title="Next page">
				<i class="bi bi-chevron-right"></i>
			</button>

			<!-- Last page -->
			<button type="button"
					class="btn btn-sm btn-outline-secondary"
					[disabled]="currentPage === totalPages"
					(click)="goToLastPage($event)"
					title="Last page">
				<i class="bi bi-chevron-double-right"></i>
			</button>
		</div>

	</mat-select>
</div>
